import { render, staticRenderFns } from "./varible-list.vue?vue&type=template&id=16122352&scoped=true&"
import script from "./varible-list.vue?vue&type=script&lang=js&"
export * from "./varible-list.vue?vue&type=script&lang=js&"
import style0 from "./varible-list.vue?vue&type=style&index=0&id=16122352&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16122352",
  null
  
)

export default component.exports